import { Label, LabelProps } from "@commonlibs";
import clsx from "clsx";
import { UserMenuOptionRoot } from "./UserMenuOption.styles";

export interface UserMenuOptionProps {
    className?: string;
    style?: React.CSSProperties;
    label: LabelProps["label"];
    children: LabelProps["children"];
}

function UserMenuOption({ className, label, children, ...rest }: UserMenuOptionProps) {
    return (
        <UserMenuOptionRoot className={clsx("user-menu-option", className)} {...rest}>
            <Label label={label} variant="body2Regular">
                {children}
            </Label>
        </UserMenuOptionRoot>
    );
}

export default UserMenuOption;
